import { render, staticRenderFns } from "./bottomWtxh.vue?vue&type=template&id=2f397f32&scoped=true"
import script from "./bottomWtxh.vue?vue&type=script&lang=js"
export * from "./bottomWtxh.vue?vue&type=script&lang=js"
import style0 from "./bottomWtxh.vue?vue&type=style&index=0&id=2f397f32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f397f32",
  null
  
)

export default component.exports